type Props = {
  fixed?: boolean;
};

function LoadBar({ fixed }: Props) {
  if (fixed) {
    return (
      <div className="fixed top-0 left-0 right-0 z-50">
        <div className="h-1 w-full animate-pulse bg-primary" />
      </div>
    );
  }
  return (
    <div className="absolute top-0 left-0 right-0 z-50">
      <div className=" h-1 w-full animate-pulse bg-primary" />
    </div>
  );
}

export default LoadBar;
